$("#next-question").on("click", function () {
  $(".ask-question-box__answer").fadeOut(200);
});
